const BREAKPOINTS = {
  smallPalm: 480,
  mobile: 600,
  handheld: 800,
  portable: 1024
};

const MIN_SELECTORS = Object.keys(BREAKPOINTS).reduce((obj, key) => {
  const value = BREAKPOINTS[key] + 1;
  obj[key] = `(min-width: ${value}px)`;

  return obj;
}, {});

export default BREAKPOINTS;
export { MIN_SELECTORS };



// WEBPACK FOOTER //
// ./const/breakpoints.js